import { render, staticRenderFns } from "./ChatMessageBar.vue?vue&type=template&id=832fd48a&scoped=true"
import script from "./ChatMessageBar.vue?vue&type=script&lang=js"
export * from "./ChatMessageBar.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageBar.vue?vue&type=style&index=0&id=832fd48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832fd48a",
  null
  
)

export default component.exports